import React from "react";
import { Icon } from "../../icons/icons";

const Step = ({ children, status = 0 }) => {
  const colors = {
    0: "text-[#B2C2CB]",
    1: "text-[#4BAE4F]",
    2: "text-brand-color-primary",
  };

  return (
    <div className="flex flex-col justify-center items-center gap-y-[10px] flex-[0_0_10%]">
      <div className={colors[status]}>
        <Icon name={"guestconfirmation"}></Icon>
      </div>
      <span className={"text-[14px] font-semibold leading-5 " + colors[status]}>
        {children}
      </span>
    </div>
  );
};

export default Step;
